import React from 'react';

function invokeCloudRecovery() {
  try {
    const recovery = window.__VR_CLOUD_SAVE_DRAFT__;
    if (typeof recovery !== 'function') return Promise.resolve({ ok: false, reason: 'unavailable' });
    return Promise.resolve(recovery()).then(
      () => ({ ok: true }),
      (error) => ({ ok: false, reason: error?.message || 'save failed' })
    );
  } catch (error) {
    return Promise.resolve({ ok: false, reason: error?.message || 'save failed' });
  }
}

export default class CloudErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, recovery: 'idle' };
  }

  static getDerivedStateFromError(error) {
    return { error, recovery: 'saving' };
  }

  componentDidCatch(error, info) {
    // Keep technical details in the console while the recovery screen stays actionable.
    console.error('VR cloud editor render error', error, info);
    invokeCloudRecovery().then((result) => {
      this.setState({ recovery: result.ok ? 'saved' : 'failed' });
    });
  }

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const recoveryText = {
      saving: '正在尝试保存最近一次云端草稿…',
      saved: '最近一次云端草稿已提交，重新打开后会从服务端恢复。',
      failed: '未能确认崩溃前的草稿是否提交；重新打开后仍会读取服务端最后一个版本。',
      idle: '重新打开后会读取服务端最后一个版本。',
    }[this.state.recovery] || '重新打开后会读取服务端最后一个版本。';

    return (
      <main className="cloud-recovery-screen" role="alert">
        <section className="cloud-recovery-card">
          <div className="cloud-eyebrow">VR TOUR CLOUD</div>
          <h1>云端编辑器遇到异常</h1>
          <p>{recoveryText}</p>
          <p className="cloud-recovery-note">原图上传和已保存的项目版本不会因这次页面异常而被浏览器清除。</p>
          <button type="button" className="cloud-primary" onClick={this.reload}>
            重新打开云端项目
          </button>
        </section>
      </main>
    );
  }
}
